export default "/assets/images/dog-face.706e0b39aeb4ca37.png";